import { IDENTITY_CARDS } from '../constants';
import SignalCard from './signal-card';

function IdentityStrip() {
  return (
    <section aria-label="FEVERDREAM identity facts" className="mx-auto grid max-w-6xl gap-4 px-5 py-8 md:grid-cols-3">
      {IDENTITY_CARDS.map((card, index) => (
        <SignalCard key={card.label} label={card.label} value={card.value} dark={index === 0} />
      ))}
    </section>
  );
}

export default IdentityStrip;
